import { render } from "./QiluBack.vue?vue&type=template&id=2d41ead0&scoped=true"
import script from "./QiluBack.vue?vue&type=script&lang=js"
export * from "./QiluBack.vue?vue&type=script&lang=js"

import "./QiluBack.vue?vue&type=style&index=0&id=2d41ead0&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d41ead0"]])

export default __exports__